export const LEGAL_REVIEW_DATE = '1 May 2026';
